<template>
  <el-tabs v-model="tabPaneVal" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="企业资料" name="ShipmentEdit">
      <ShipmentEdit v-if="isShipmentEditShow" ref="ShipmentEditRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane v-if="!ctmsShow" label="开票信息管理" name="InvoiceMessage">
      <InvoiceMessage v-if="isInvoiceMessageShow" ref="InvoiceMessageRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane label="地址管理" name="CommonRouteInfo">
      <CommonRouteInfo v-if="isCommonRouteInfoShow" ref="CommonRouteInfoRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane v-if="!ctmsShow" label="承运分组" name="VehicleTeam">
      <VehicleTeam v-if="isVehicleTeamShow" ref="VehicleTeamRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane label="员工管理" name="ShipmentStaff">
      <ShipmentStaff v-if="isShipmentStaffShow" ref="ShipmentStaffRef" :parent-data="parentData" />
    </el-tab-pane>
    <!-- <el-tab-pane label="上游客户管理" name="UpstreamCustomer">
      <UpstreamCustomer v-if="isUpstreamCustomerShow" ref="UpstreamCustomerRef" :parent-data="parentData" />
    </el-tab-pane> -->
    <el-tab-pane v-if="!ctmsShow" label="合同管理" name="ShipmentContract">
      <ShipmentContract v-if="isShipmentContractShow" ref="ShipmentContractRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane v-if="this.$route.query.partyCode" label="权限管理" name="jurisdictManage">
      <jurisdictManage v-if="isjurisdictManageShow" ref="jurisdictManageRef" :parent-data="parentData" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import ShipmentEdit from "./components/shipmentEdit.vue";
import InvoiceMessage from "./components/invoiceMessage/invoiceMessageList.vue";
import CommonRouteInfo from "./components/commonRouteInfo/commonRouteInfoList.vue";
import VehicleTeam from "./components/vehicleTeam/vehicleTeamList.vue";
import ShipmentStaff from "./components/shipmentStaff/shipmentStaffList.vue";
// import UpstreamCustomer from "./components/upstreamCustomer/upstreamCustomerList.vue";
import ShipmentContract from "./components/shipmentContract/shipmentContractList.vue";
import jurisdictManage from "./components/jurisdictManage/jurisdictManage";
import { getListDict, getGoodsTypeDict, getShipperList } from "@/api/shipment";
import { getRole } from "@/utils/getRole";
export default {
  name: "EditShipmentCompanyForm",
  components: {
    ShipmentEdit,
    InvoiceMessage,
    CommonRouteInfo,
    VehicleTeam,
    ShipmentStaff,
    // UpstreamCustomer,
    ShipmentContract,
    jurisdictManage,
  },
  data() {
    return {
      companyCode: "",
      parentData: {
        isCompany: true,
        areaOptions: this.$store.state.components.areaOptions,
        goodsTypeList: [],
        typeOptions: [],
        vehicleDictList: [],
        bankOptions: [],
        receiverUserCodeOptions: [],
        upstreamCustomerList: [],
        branchCode: "",
      },
      queryData: {},
      tabPaneVal: "ShipmentEdit",
      isShipmentEditShow: true,
      isInvoiceMessageShow: false,
      isCommonRouteInfoShow: false,
      isVehicleTeamShow: false,
      isShipmentStaffShow: false,
      isUpstreamCustomerShow: false,
      isPriceSystemShow: false,
      isCustomerManageShow: false,
      isLineManagementShow: false,
      isShipmentContractShow: false,
      isjurisdictManageShow: false,
      ctmsShow: false,
    };
  },
  watch:{
    // 监听路由刷新
    // '$route':function(route){
    //   // if(route.query.code!=this.companyCode&&route.path.indexOf("editShipmentCompanyForm")>-1){
    //   if(route.query.code&&route.path.indexOf("editShipmentCompanyForm")>-1){
    //     this.tabPaneVal = 'ShipmentEdit'
    //     this.isShipmentEditShow = true
    //     this.isInvoiceMessageShow = false
    //     this.isCommonRouteInfoShow = false
    //     this.isVehicleTeamShow = false
    //     this.isPriceSystemShow = false
    //     this.isCustomerManageShow = true
    //     this.isLineManagementShow = false
    //     this.isShipmentContractShow = false
    //   }
    // }
  },
  created() {
    this.ctmsShow = getRole();
    this.queryData = this.$route.query;
    this.companyCode = this.$route.query.code ? this.$route.query.code : "";
    this.parentData.partyCode = this.$route.query.partyCode ? this.$route.query.partyCode : "";
    this.parentData.branchCode = this.$route.query.branchCode
    // 收票人选项
    getShipperList({ staffTypes: "1,4,6", companyCode: this.companyCode }).then(
      (response) => {
        this.parentData.receiverUserCodeOptions = response.data.records;
      }
    );
    // 上游客户
    getShipperList({ staffType: "5", companyCode: this.companyCode }).then(
      (response) => {
        this.parentData.upstreamCustomerList = response.data.records;
      }
    );
    // 货物类型字典
    getGoodsTypeDict({ parentCode: "goodsBigType", partyGroupCode:this.parentData.branchCode }).then((response) => {
      this.parentData.goodsTypeList = response.data.records;
    });
    // 开票方式、车型、开户银行
    getListDict({ types: "vehicleClassification, bank",branchCode:this.parentData.branchCode }).then(
      (response) => {
        this.parentData.vehicleDictList = response.data.filter(
          (item) => item.type === "vehicleClassification"
        )[0]["dictList"];
        this.parentData.bankOptions = response.data.filter(
          (item) => item.type === "bank"
        )[0]["dictList"];
      }
    );
  },
  methods: {
    handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList();
      });
      // 重新获取 收票人
      if (tab.name === "InvoiceMessage") {
        getShipperList({
          staffTypes: "1,4,6",
          companyCode: this.companyCode,
        }).then((response) => {
          this.parentData.receiverUserCodeOptions = response.data.records;
        });
      }
      // 重新获取 上游客户
      if (tab.name === "UpstreamCustomer") {
        getShipperList({ staffType: "5", companyCode: this.companyCode }).then(
          (response) => {
            this.parentData.upstreamCustomerList = response.data.records;
          }
        );
      }
    },
  },
};
</script>
